
























































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { DxScrollView, DxTextBox } from "devextreme-vue";
import DxNumberBox from "devextreme-vue/number-box";
import DxColorBox from "devextreme-vue/color-box";
import DButton from "@/components/DButton/button.vue";
import ImbalanceService from "@/services/imbalance_service";
import { ImbalanceColorSettings } from "@/services/models-service";
import _ from "lodash";
import {alert, confirm} from 'devextreme/ui/dialog';

@Component({
  name: "ImbalanceColors",
  components: {
    DButton,
    DxTextBox,
    DxScrollView,
    DxNumberBox,
    DxColorBox,
  },
})
export default class ImbalanceColors extends Vue {
  colorSettings: ImbalanceColorSettings = new ImbalanceColorSettings();
  public oldColorSettings: ImbalanceColorSettings = new ImbalanceColorSettings();
  public settingsChanged: boolean = false;
  public isLoading: boolean = false;

  async created() {
    this.isLoading = true;
    const raw = await ImbalanceService.getImbalanceColors();
    this.colorSettings = new ImbalanceColorSettings(raw);
    this.oldColorSettings = _.cloneDeep(this.colorSettings);
    this.$nextTick(() => {
      this.isLoading = false;
    });
  }

  beforeRouteLeave (to:any, from: any, next: any) {
    console.log("beforeRouteLeave triggered");
  }

  @Watch("colorSettings", { deep: true })
  onColorSettingsChanged(newVal: ImbalanceColorSettings) {
    if (this.isLoading) return;
    this.settingsChanged = JSON.stringify(newVal) !== JSON.stringify(this.oldColorSettings);
  }

  async saveColors() {
    if (!this.validateBeforeSave()) return;

    const success = await ImbalanceService.updateImbalanceColors(
      this.colorSettings
    );
    if (success) {
      this.$notify({
        type: "success",
        title: "Успех",
        message: "Настройки сохранены",
      });
      this.oldColorSettings = _.cloneDeep(this.colorSettings);
      this.settingsChanged = false;
      return {message: 'success', status: true};
    } else {
      this.$notify({
        type: "error",
        title: "Ошибка",
        message: "Ошибка при сохранении",
      });
      return {message: 'error', status: false};
    }
  }
  
  async revertColors() {
    this.colorSettings = _.cloneDeep(this.oldColorSettings);
    this.settingsChanged = false;
  }

  handleSepValueChange(groupKey: string, field: 'sep1' | 'sep2', value: number | null | undefined) {
    if (value === null || value === undefined) return;
    
    const absValue = Math.abs(value);
    
    const group = this.colorSettings[groupKey as keyof ImbalanceColorSettings] as any;
    this.$set(group, field, absValue);
    
    if (group.sep1 !== null && group.sep1 !== undefined && 
        group.sep2 !== null && group.sep2 !== undefined) {
      if (group.sep1 >= group.sep2) {
        this.$notify({
          type: "warning",
          title: "Внимание",
          message: `Первое значение должно быть строго меньше второго`,
        });
      }
    }
  }

  validateBeforeSave() {
    for (const [key, group] of Object.entries(this.colorSettings)) {
      if (
        group.sep1 === null ||
        group.sep1 === undefined ||
        group.sep2 === null ||
        group.sep2 === undefined
      ) {
        this.$notify({
          type: "warning",
          title: "Внимание",
          message: `В блоке ${key}: оба значения обязательны`,
        });
        return false;
      }

      const absSep1 = Math.abs(group.sep1);
      const absSep2 = Math.abs(group.sep2);
      
      if (absSep1 >= absSep2) {
        this.$notify({
          type: "warning",
          title: "Внимание",
          message: `В блоке ${key}: первое значение должно быть строго меньше второго`,
        });
        return false;
      }
    }
    return true;
  }
}
